module.exports = __webpack_public_path__ + "static/media/about-header-2.bb9c7f37.jpg";